import { Expose } from 'class-transformer';
import { BasicUser } from './basic-user-model';

export class TeachersPerformanceReport extends BasicUser {
  @Expose() totalOnline: string;
  @Expose() totalSessions: string;
}
